import React, { useState, useEffect } from 'react';

import { Switch } from 'antd';

import styled from 'styled-components';

import { enumerateDaysBetweenDates } from '@libs/NwUtils';

import { getContactName } from '@hooks/API/Contact/UseContactsList';
import { onGetOptionNumber } from '@hooks/API/Event/UseEvent';

import ModelAvailability from '@components/EventDatesPicker/ModelAvailability';
import MiniLoading from '@components/Gui/MiniLoading';
import RadioButtonGroup from '@components/Gui/NwForm/RadioButtonGroup';

const Wrapper = styled.div`
    margin-bottom: 0.75rem;

    @media (max-width: 768px) {
        margin-bottom: 0.75rem;
        padding-bottom: 0.75rem;
        border-bottom: ${(props) => props.theme.DefaultBorder};
    }

    .model-wrapper {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 0.5rem;
        padding-bottom: 0.5rem;

        @media (max-width: 768px) {
            flex-direction: column;
            align-items: flex-start;
            gap: 0.75rem;
        }

        .model-item {
            .model-item-switch {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                margin-bottom: 0.5rem;

                p {
                    margin: 0;
                }
            }
        }
    }
    .option-number-recalculated {
        display: block;
        font-size: ${(props) => props.theme.FontSizeSm};
        color: ${(props) => props.theme.DangerColor};
    }
`;

const EventDateModel = ({ modelId, models, eventId, eventType, period, onChange }) => {
    const [loading, setLoading] = useState(false);
    const [recalculated, setRecalculated] = useState(false);
    const [isCalled, setIsCalled] = useState(false);

    useEffect(() => {
        if (models[modelId].checked && models[modelId].optionNumber < 10 && eventType !== 'Casting') {
            onCheckOptionNumber();
        }

    }, [models[modelId].checked, period]);

    const onCheckOptionNumber = async () => {
        const data = {
            EventID: eventId,
            ModelID: modelId,
            Dates: enumerateDaysBetweenDates(period[0], period[1]),
        };

        setLoading(true);
        try {
            const optionNumber = await onGetOptionNumber(data);
            if (models[modelId].optionNumber && isCalled) {
                setRecalculated(true);
            }
            if (!isCalled) {
                setIsCalled(true);
            }
            setLoading(false);
            return onChange(modelId, modelChecked, optionNumber[0].SuggestedOptionNumber);
        } catch (error) {
            console.error('Update Option Number Error => ', error);
            setLoading(false);
        }
    };

    const modelChecked = models[modelId] ? models[modelId].checked : false;
    const modelOptionNumber = models[modelId] ? models[modelId].optionNumber : null;

    return (
        <Wrapper>
            <div className="model-wrapper">
                <div className="model-item">
                    <div className="model-item-switch">
                        <Switch
                            checked={modelChecked}
                            onChange={(checked) => {
                                onChange(modelId, checked, modelOptionNumber);
                                if (!checked) {
                                    setRecalculated(false);
                                    setIsCalled(false);
                                }
                            }}
                        />
                        <p>{getContactName(modelId)}</p>
                    </div>
                    {modelChecked && (
                        <ModelAvailability
                            startDate={period[0]}
                            endDate={period[1]}
                            modelId={modelId}
                            eventId={eventId}
                        />
                    )}
                </div>
                {modelChecked &&
                    eventType !== 'Casting' &&
                    (loading ? (
                        <MiniLoading />
                    ) : (
                        <div>
                            <RadioButtonGroup
                                value={modelOptionNumber}
                                onChange={(value) => {
                                    if (value === 'auto') {
                                        onCheckOptionNumber();
                                    } else {
                                        onChange(modelId, modelChecked, value);
                                    }
                                }}
                                size="small"
                                options={[
                                    { value: 10, label: 'job' },
                                    ...[...Array(5).keys()].map((key) => ({ value: key + 1, label: key + 1 })),
                                    { value: 'auto', label: 'auto' },
                                ]}
                            />
                            {recalculated && (
                                <span className="option-number-recalculated">option number re-calculated</span>
                            )}
                        </div>
                    ))}
            </div>
        </Wrapper>
    );
};

export default EventDateModel;
